import React from 'react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import '../assets/styles/Menu.css';

const MenuItems = ({ closeDrawer }) => {
    const handleMenuClick = (e) => {
        if (closeDrawer) {
            closeDrawer();
        }
    };

    return (
        <>
            <Menu.Item key="1" onClick={handleMenuClick}>
                <Link to="/" className="menu-link">Home</Link>
            </Menu.Item>
            <Menu.Item key="2" onClick={handleMenuClick}>
                <Link to="/challenges" className="menu-link">Challenges</Link>
            </Menu.Item>
            <Menu.Item key="3" onClick={handleMenuClick}>
                <Link to="/projects" className="menu-link">Projects</Link>
            </Menu.Item>
            <Menu.Item key="4" onClick={handleMenuClick}>
                <Link to="/learning" className="menu-link">Learning</Link>
            </Menu.Item>
            <Menu.Item key="5" onClick={handleMenuClick}>
                <Link to="/mentorship" className="menu-link">Mentorship</Link>
            </Menu.Item>
            <Menu.Item key="6" onClick={handleMenuClick}>
                <Link to="/Assessments" className="menu-link">Assessments</Link>
            </Menu.Item>
            <Menu.Item key="7" onClick={handleMenuClick}>
                <Link to="/courses" className="menu-link">Courses</Link>
            </Menu.Item>
            {/* <Menu.Item key="8" onClick={handleMenuClick}>
                <Link to="/newsroom" className="menu-link">News</Link>
            </Menu.Item> */}
            <Menu.Item key="9" onClick={handleMenuClick} className="menu-item-button">
                <Link to="/donate" className="menu-link rounded-button donate-button">
                    Donate
                </Link>
            </Menu.Item>
            <Menu.Item key="10" onClick={handleMenuClick} className="menu-item-button">
                <Link to="/signin" className="menu-link rounded-button login-button">
                Sign in
                </Link>
            </Menu.Item>
            <Menu.Item key="11" onClick={handleMenuClick} className="menu-item-button">
                <Link to="/signup" className="menu-link rounded-button signup-button">
                    Join Now
                </Link>
            </Menu.Item>

            {/* Internal CSS with dangerouslySetInnerHTML */}
            <style
                dangerouslySetInnerHTML={{
                    __html: `
                        .menu-link {
                            font-size: 13px;
                            color: #cccc;
                        }
                        .menu-link:hover {
                            color: #1890ff !important;
                        }
                    `,
                }}
            />
        </>
    );
};

export default MenuItems;